import RecoveryRecordBuilderBase from "slotworks/integration/revolver/builders/records/recovery-record-builder-base";
import { OpenRecordSchema } from "slotworks/integration/revolver/schema/close-record-schema";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import betModel from "slotworks/model/bets/bet-model";
import DSComponents from "components/components";
import icBonusRecordBuilder from "./ic-bonus-record-builder";
import gameState from "slotworks/model/game-state";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";
import FreespinRecord from "./schema/freespin-record";
import slotDefinition from "slotworks/model/slot-definition";
import Components from "slotworks/components/components";
import RevolverSettings from "model/revolver-settings";

class POTCRecoveryRecordBuilder extends RecoveryRecordBuilderBase {

    public build(gameplay: Gameplay, data: any): Record[] {
        RevolverSettings.isCountupPlayed = false
        const openResponse: OpenRecordSchema = data.data as OpenRecordSchema;
        const persistedProgress = (openResponse.OPEN as any).persisted_progress;
        if (persistedProgress && persistedProgress.potsValues) {
            DSComponents.coinPots.setPersistedPotLevels(persistedProgress);
            DSComponents.coinPots.setPotLevelsFromBet(betModel.getTotalBet());
        }
        if (persistedProgress && persistedProgress.progressiveJackpot) {
            DSComponents.jackpotMeter.setValues(persistedProgress.progressiveJackpot);
        } else {
            DSComponents.jackpotMeter.setValues([]);
        }

        const isLateFreespins = gameState.getCurrentGame().isRecovered && revolverModel.isFreespin(openResponse.OPEN.game);

        if (isLateFreespins) {
            const firstRecord = gameState.getCurrentGame().getFirstRecord();
            if (!(firstRecord instanceof FreespinRecord) && !firstRecord.beenPaid) {
                const preservedDummyWin = gameState.getCurrentGame().getFirstRecord().creditsWon;

                const dummySpinRecord = new FreespinRecord();
                gameState.getCurrentGame().records[0] = dummySpinRecord;
                this.populateDummy(dummySpinRecord);
                dummySpinRecord.totalFreespins = openResponse.OPEN.state.total;
                dummySpinRecord.remainingFreespins = openResponse.OPEN.state.remain;
                const recoveredFSWin = parseFloat(openResponse.OPEN.state.total_win_cash as any);
                dummySpinRecord.creditsWon = recoveredFSWin + preservedDummyWin;

                gameplay.totalCreditsWon += parseFloat(recoveredFSWin as any);
                gameplay.totalFreespinsCreditsWon += recoveredFSWin;
            }

            return [];
        }

        if (openResponse.USER) {
            gameplay.balance = openResponse.USER.balance;
        }

        revolverModel.game = openResponse.OPEN.game;
        revolverModel.bet = JSON.stringify(openResponse.OPEN.bet_state);

        const recoveryRecords: Record[] = [];

        if (openResponse.OPEN.game.indexOf("BASE") === -1) {
            gameplay.isRecovered = true;

            const isFreeSpin = revolverModel.isFreespin(openResponse.OPEN.game) || revolverModel.isFreespin((openResponse.OPEN.state as any).triggering_game);
            const dummySpinRecord = isFreeSpin ? new FreespinRecord() : new SpinRecord(); // todo here
            this.populateDummy(dummySpinRecord);

            recoveryRecords.push(dummySpinRecord);

            const betState = openResponse.OPEN.bet_state;
            const coinLevel = slotDefinition.coinSizes[betState.coin_level - 1];
            betModel.setDefaults(slotDefinition.stakes[betState.bet_level - 1], betState.lines, coinLevel);
            Components.paytable.refreshBetOptions();

            this.recoverBonuses(gameplay, data, openResponse, dummySpinRecord, recoveryRecords);
        }

        return recoveryRecords;
    }

    protected recoverBonuses(gameplay: Gameplay, data: any, openResponse: OpenRecordSchema, dummySpinRecord: SpinRecord, recoveryRecords: Record[]) {
        // super.recoverBonuses(gameplay, data, openResponse, dummySpinRecord, recoveryRecords);
        // (Components.paytable as any).cachedBetOptions = betModel.generateBetOptions();        
        if (openResponse.OPEN.game.indexOf("BONUS") > -1) {
            const bonusResult = new BonusResult("BONUS");
            dummySpinRecord.results.push(bonusResult);

            recoveryRecords.push(...icBonusRecordBuilder.build(gameplay, data));

            if (revolverModel.isFreespin((openResponse.OPEN.state as any).triggering_game)) {
                if (openResponse.OPEN.state.total_bonus_games_win_amount) {
                    gameplay.recoveredFreeSpinTotalWin += parseFloat(openResponse.OPEN.state.total_bonus_games_win_amount as any);
                    gameplay.totalCreditsWon += parseFloat(gameplay.recoveredFreeSpinTotalWin as any);
                    gameplay.totalFreespinsCreditsWon += parseFloat(gameplay.recoveredFreeSpinTotalWin as any);
                    gameplay.isRecovered = true;
                }
            }
        } else {
            super.recoverBonuses(gameplay, data, openResponse, dummySpinRecord, recoveryRecords);
        }
    }

    private populateDummy(record: SpinRecord) {
        record.creditsWon = 0;
        record.reelset = [];
        record.grid = [];
        record.stops = [];
        record.results = [];
        record.freespinsWon = 0;
    }

}

export default new POTCRecoveryRecordBuilder();
